import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'fiscality-type-form',
    templateUrl: './fiscality-type-form.component.html',
    styleUrls: ['./fiscality-type-form.component.scss'],
    standalone: false
})
export class FiscalityTypeFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options: FormControlOption[] = [
    {
      value: 'VERSEMENT_154_BIS',
      label: '154 bis ou 154 bis-0 A du CGI',
      suffix: { title: 'A' },
    },
    {
      value: 'VERSEMENT_163_QUATERVICIES',
      label: '163 quatervicies du CGI',
      suffix: { title: 'B' },
    },
  ];
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  getLabelFiscalityField() {
    const operation = this.operation?.value;
    if (operation !== 'SUBSCRIPTION') {
      return 'Fiscalité de votre versement';
    }

    const avInvestmentType = this.avInvestmentType?.value;
    if (avInvestmentType === 'INITIAL_AND_MONTHLY') {
      return 'Fiscalité de votre versement initial';
    }

    return 'Fiscalité de votre versement';
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
